import React from 'react';
import { SvgIcon } from '@mui/material';

/**
 * Wand Icon Component - Location pin with sparkle stars
 * Perfect for "suggest activities" and other AI-powered actions
 * 
 * Usage:
 * import WandIcon from './components/WandIcon';
 * <WandIcon />
 * <WandIcon fontSize="large" />
 * <WandIcon sx={{ color: 'primary.main' }} />
 */
const WandIcon = (props) => (
  <SvgIcon {...props}>
    {/* Small sparkle star at top left */}
    <path d="M4.5 2L5.34 3.84L7.18 4.68L5.34 5.52L4.5 7.36L3.66 5.52L1.82 4.68L3.66 3.84L4.5 2Z" fill="currentColor"/>
    
    {/* Location pin outline */}
    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    
    {/* Sparkle star inside pin */}
    <path d="M12 6L12.8 8.2L15 9L12.8 9.8L12 12L11.2 9.8L9 9L11.2 8.2L12 6Z" fill="currentColor"/>
  </SvgIcon>
);

export default WandIcon;
